module.exports = __webpack_public_path__ + "c3e8c52fe0ba6d21e3ca362573aaa2a0.gif";